module.exports = __webpack_public_path__ + "static/2phones_splash-4f6da39788584f123a077f4d1dbd2b95.png";